var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* パスワード変更（職員、お客様共通） */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import axios from '../axios';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import 'url-search-params-polyfill';
import LoadingModal from '../organisms/LoadingModal';
import { isBrowserIe } from '../BrowserJudgment';
import { jumpUrl } from '../Common';
import { getLanguage } from '../Common';
import { useTranslation } from 'react-i18next';
import '../i18n';
var PasswordChange = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    // 処理結果通知ダイアログ
    var _b = useState(false), show = _b[0], setShow = _b[1];
    var handleShow = function () { return setShow(true); };
    var handleClose = function () { return setShow(false); };
    var successDialogMessage = t('パスワードを変更しました。');
    var failDialogMessage = t('パスワードの変更が失敗しました。');
    // パスワード
    var _c = useState(''), password = _c[0], setPassword = _c[1];
    // パスワード(確認)
    var _d = useState(''), password_confirmation = _d[0], setPasswordConfirmation = _d[1];
    var _e = useState(''), password_change_message = _e[0], setPasswordChangeResult = _e[1];
    var _f = useState(''), dialog_message = _f[0], setDialogMessage = _f[1];
    var _g = useState(0), status_code = _g[0], setStatusCode = _g[1];
    // API通信中フラグ
    var _h = useState(false), is_connecting = _h[0], setIsConnecting = _h[1];
    //ローディング画面表示状態
    var _j = useState(false), is_loading = _j[0], setIsLoading = _j[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        // 言語変更
        i18n.changeLanguage(getLanguage());
    }, []);
    // モーダルクローズ & ログイン画面に遷移
    var redirectToLogin = function () {
        var location_url = location.search;
        var email_hash = new URLSearchParams(location_url).get('email_hash');
        //リセットメールからの遷移時の場合はログイン画面へ遷移する。
        if (email_hash !== undefined && email_hash !== null) {
            location.replace(process.env.MIX_MOCK_URL + "/mypage/login");
        }
        else {
            // ログイン画面へ遷移する
            location.replace(process.env.MIX_MOCK_URL + "/login");
        }
    };
    // パスワード変更ボタンのクリックイベントを定義
    var handlePasswordChange = function () {
        //メールからの画面遷移の場合
        var location_url = location.search;
        var email_hash = new URLSearchParams(location_url).get('email_hash');
        // ログイン情報をStateへセット
        // 結果表示ボックスに適用するCSSクラス名
        var password_info = {
            password: password,
            password_confirmation: password_confirmation,
            email_hash: email_hash !== null ? email_hash : '',
        };
        var passwordChange = function () { return __awaiter(void 0, void 0, void 0, function () {
            var url, response, error_1, is_login;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        url = "/password/change";
                        return [4 /*yield*/, axios.post(url, password_info)];
                    case 1:
                        response = _a.sent();
                        setDialogMessage(successDialogMessage);
                        setStatusCode(response.status);
                        // ダイアログ表示
                        handleShow();
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        is_login = document.getElementById('is_login');
                        //行員の場合
                        if (is_login !== null && !is_login.value) {
                            // 未ログインの場合
                            jumpLoginDisp();
                        }
                        else {
                            // ログイン済の場合
                            jumpUrl(error_1.response.data.url);
                        }
                        setPasswordChangeResult(error_1.response.data.message);
                        setStatusCode(error_1.response.status);
                        setDialogMessage(failDialogMessage);
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // パスワード変更処理
        passwordChange();
    };
    // 要素のセンタリングのクラス名を動的に生成する（IEは生成しない、それ以外は生成する）
    var justify_content_center = isBrowserIe() ? '' : 'justify-content-center';
    /**
     * 戻るボタンをクリックする
     */
    var handleClickReturn = function () {
        jumpLoginDisp();
    };
    /**
     * ログイン/リスト画面へジャンプ
     */
    var jumpLoginDisp = function () {
        // domからログインユーザー情報を読み取る
        var is_applicant = document.getElementById('is_applicant');
        var is_login = document.getElementById('is_login');
        // 行員
        location.replace(!is_login.value
            ? "" + location.origin + process.env.MIX_MOCK_URL
            : "" + location.origin + process.env.MIX_MOCK_URL + "/staff/list" // ログインしている場合
        );
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-5" }),
        React.createElement(Block, { label: t('パスワード変更'), content: React.createElement(React.Fragment, null,
                React.createElement(Annotation, { text: t('新しいパスワードを入力してください。') }),
                React.createElement("div", { className: "mt-3" }),
                React.createElement("div", null,
                    React.createElement(Text, { id: "password", label: t('パスワード変更'), type: "password", value: password, placeholder: "", handleChange: function (event) {
                            return setPassword(event.target.value);
                        }, disabled: false, maxlength: 200 })),
                React.createElement("div", { className: "mt-3" },
                    React.createElement(Text, { id: "password-confirm", label: t('パスワード（確認）'), type: "password", value: password_confirmation, placeholder: "", handleChange: function (event) {
                            return setPasswordConfirmation(event.target.value);
                        }, disabled: false, maxlength: 200 })),
                React.createElement("div", { className: "mt-3" }),
                React.createElement(Annotation, { text: t('※パスワードは、英字・数字を含む8文字以上で設定してください。') }),
                React.createElement("div", { className: "mt-3" }),
                React.createElement(Row, { className: "d-flex align-items-center justify-content-center" },
                    React.createElement(Col, null),
                    password_change_message !== undefined &&
                        // パスワード変更失敗メッセージあり
                        status_code !== 201 && (
                    // 失敗
                    React.createElement(Col, { md: 9, className: "alert-danger alert-danger-custom" }, password_change_message)))) }),
        React.createElement("div", { className: "mt-5" }),
        React.createElement(CenterButton, { label: t('パスワード変更'), handleClick: handlePasswordChange }),
        React.createElement("div", { className: "mt-4 text-center" },
            React.createElement(Button, { variant: "main-color", className: "return-button", size: "lg", onClick: handleClickReturn }, t('戻る'))),
        React.createElement("div", { className: "mt-4" }),
        React.createElement(Modal, { className: "d-flex align-items-center " + justify_content_center, show: show, onHide: password_change_message !== undefined && status_code == 201
                ? redirectToLogin
                : handleClose, animation: false },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, { className: "dialog-title" })),
            React.createElement(Modal.Body, { className: "dialog-body" }, dialog_message),
            React.createElement(Modal.Footer, null, password_change_message !== undefined &&
                // パスワード変更結果メッセージあり
                (status_code == 201 ? (
                // 成功
                React.createElement(Button, { variant: "primary", onClick: redirectToLogin }, "OK")) : (
                // 失敗
                React.createElement(Button, { variant: "secondary", onClick: handleClose }, "OK"))))),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('password-change')) {
    ReactDOM.render(React.createElement(PasswordChange, null), document.getElementById('password-change'));
}
